<template>
  <div class="loading-bar" :class="loading && 'loading-bar-active'">
    <div class="loading-bar-1 primary"></div>
    <div class="loading-bar-2 primary"></div>
    <div class="loading-bar-3 primary"></div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'StateButton',
  props: {
    loading: Boolean
  }
});
</script>

<style scoped lang="scss">
.loading-bar {
  width: 100%;
  height: 0px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  transition: height 200ms ease-in-out;
}

.loading-bar-1 {
  height: 100%;
  width: 0%;
  opacity: 0.2;
}

.loading-bar-2 {
  height: 100%;
  width: 0%;
  opacity: 0.8;
}

.loading-bar-3 {
  height: 100%;
  width: 100%;
  opacity: 0.4;
}

.loading-bar.loading-bar-active {
  height: 6px;
  .loading-bar-1 {
    animation: progress-animation1 1s linear;
    animation-iteration-count: infinite;
  }

  .loading-bar-2 {
    animation: progress-animation2 1s linear;
    animation-iteration-count: infinite;
  }

  .loading-bar-3 {
    animation: progress-animation3 1s linear;
    animation-iteration-count: infinite;
  }
}

@keyframes progress-animation1 {
  0% {
    width: 0%;
  }
  25% {
    width: 0%;
  }
  50% {
    width: 20%;
  }
  80% {
    width: 60%;
  }
  100% {
    width: 100%;
  }
}
@keyframes progress-animation2 {
  0% {
    width: 20%;
  }
  80% {
    width: 70%;
  }
  90% {
    width: 20%;
  }
  0% {
    width: 0%;
  }
}
@keyframes progress-animation3 {
  0% {
    width: 100%;
  }
  25% {
    width: 80%;
  }
  50% {
    width: 60%;
  }
  75% {
    width: 20%;
  }
  100% {
    width: 0%;
  }
}
</style>
